<template>
    <div>

        <!-- Header Start -->
        <div style="margin-bottom: 28px; display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
            <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">QR Distribution Monitoring</h2>
            <div style="display: flex; flex-direction: row;">
                <div style="background-color: white; border-radius: 4px; position: relative; border: 0">
                    <span style="pointer-events: none; position: absolute; top: 0; bottom: 0; inset-inline-start: 0px; width: 40px; place-content: center; color: rgb(107 114 128); display: grid;">
                        <i class="fas fa-calendar"></i>
                    </span>
                    <flat-pickr v-model="selected.date" :config="dateRangeConfig"></flat-pickr>
                </div>
                <button
                    type="button"
                    class="btn"
                    style="background-color: white; padding: 0 20px; border-radius: 4px; margin-left: 20px; display: flex; align-items: center; font-size: 14px; cursor: pointer; font-weight: 500;"
                >Download CSV <i class="fas fa-file-download" style="margin-left: 8px;"></i></button>
            </div>
        </div>
        <!-- Header End -->

        <!-- Stats Start -->
        <div class="bg-white rounded shadow-sm mb-4" style="padding: 20px">
            <h3 class="h5 font-weight-semibold">Rangkuman Distribusi</h3>
            <div class="row stats-row">
                <div class="col">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/saldo-awal.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">Saldo Awal</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">1.500</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/in-transit-md.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">In Transit MD</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">12.000</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/diterima-md.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">Diterima MD</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">7.350</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/in-transit-dealer.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">In-Transit Dealer</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">3.150</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/diterima-dealer.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">Diterima Dealer</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">7.350</p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="d-flex flex-row align-items-center">
                        <img src="@/assets/img/icon/saldo-akhir.png" style="height: 32px;">
                        <div class="d-flex flex-column ml-3">
                            <p style="margin-bottom: 0; font-size: 16px;">Saldo Akhir</p>
                            <p style="font-size: 20px; font-weight: 600; margin: 0">3.000</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Stats End -->

        <!-- Delivery Trend Start -->
        <div class="bg-white rounded shadow-sm mb-4" style="padding: 20px">
            <div class="d-flex flex-row justify-content-between align-items-center">
                <h3 class="h5 font-weight-semibold">Tren Pengiriman</h3>
                <div class="d-flex flex-row align-items-center">
                    <div style="width: 200px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="All Year"
                        ></MultiSelect>
                    </div>
                    <div style="width: 200px; margin-left: 20px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="Semua Karesidenan"
                        ></MultiSelect>
                    </div>
                </div>
            </div>
            <delivery-trend></delivery-trend>
        </div>
        <!-- Delivery Trend End -->

        <!-- Mapping Trend Start -->
        <div class="bg-white rounded shadow-sm mb-4" style="padding: 20px">
            <div class="d-flex flex-row justify-content-between align-items-center">
                <h3 class="h5 font-weight-semibold">Tren Mapping</h3>
                <div class="d-flex flex-row align-items-center">
                    <div style="width: 200px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="Mapping Baru"
                        ></MultiSelect>
                    </div>
                    <div style="width: 200px; margin-left: 20px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="Semua Dealer"
                        ></MultiSelect>
                    </div>
                </div>
            </div>
            <mapping-trend></mapping-trend>
        </div>
        <!-- Mapping Trend End -->

        <!-- Distribution Projection Start -->
        <div class="bg-white rounded shadow-sm mb-4" style="padding: 20px">
            <div class="d-flex flex-row justify-content-between align-items-center">
                <h3 class="h5 font-weight-semibold">Proyeksi Distribusi</h3>
                <div class="d-flex flex-row align-items-center">
                    <div style="width: 200px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="2024"
                        ></MultiSelect>
                    </div>
                    <div style="width: 200px; margin-left: 20px;">
                        <MultiSelect
                            v-model="filter.year"
                            :options="['a', 'b', 'c']"
                            class="qtrust-select"
                            placeholder="Semua Dealer"
                        ></MultiSelect>
                    </div>
                </div>
            </div>
            <distribution-projection></distribution-projection>
        </div>
        <!-- Distribution Projection End -->

        <deliveryDetailTable></deliveryDetailTable>


    </div>
</template>

<script>
import moment from 'moment';

import deliveryTrend from './children/deliveryTrendChart.vue'
import mappingTrend from './children/mappingTrendChart.vue'
import distributionProjection from './children/distributionProjectionChart.vue'
import deliveryDetailTable from './children/deliveryDetailTable.vue'

export default {
    metaInfo : {
        title : 'Distribution Monitoring'
    },
    data () {
        let start = moment().subtract(14, 'days').format("YYYY-MM-DD");
        let end = moment().format("YYYY-MM-DD");
        return {
            dateRangeConfig: {
                mode: "range",
                altFormat: "d-m-Y",
                dateFormat: "Y-m-d",
                altInput: true,
                altInputClass: "flatpickr-alt",
                maxDate: moment().format("YYYY-MM-DD"),

                //Max number of days
                onChange: (selectedDates, dateStr, instance) => {
                    if (selectedDates.length == 1) {
                        let fourteenDaysLater = new Date(
                            selectedDates[0].getTime() + 86400000 * 14
                        )
                        // console.log(
                        //     '14 days later is: ',
                        //     fourteenDaysLater,
                        //     selectedDates[0]
                        // )

                        instance.config.minDate = selectedDates[0].toUTCString()
                        instance.config.maxDate = fourteenDaysLater.toUTCString()
                    } else if (selectedDates.length == 2) {
                        instance.config.minDate = null
                        instance.config.maxDate = end
                    }
                },
            },

            selected: {
                date: `${start} to ${end}`,
            },
            filter : {
                year: null,
                date: {
                    start: start,
                    end: end
                }
            },

        }
    },
    components : {
        deliveryTrend,
        mappingTrend,
        distributionProjection,
        deliveryDetailTable,
    },
    mounted () {

    },
    watch : {
        'selected.date'() {
            let dates = this.selected.date.split(' to ');
            this.filter.date.start = dates[0];
            this.filter.date.end = dates[1] ? dates[1] : dates[0];

            setTimeout(() => {
                this.generateDatas();
            }, 1000);
        }
    },
    methods : {

    }
}
</script>

<style>
    .flatpickr-alt {
        font-size: 14px;
        min-width: 260px;
        padding: 0 12px;
        height: 32px;
        background-color: transparent;
        padding-inline-start: 40px;
        cursor: pointer;
        border: 0;
    }

    .qtrust-select {
        min-height: 0;
    }

    .qtrust-select .multiselect__tags {
        min-height: 0;
        height: 32px;
        padding: 4px 40px 0 8px;
    }

    .qtrust-select .multiselect__tags .multiselect__placeholder {
        margin: 0;
        padding: 0;
        font-size: 14px;
    }

    .qtrust-select .multiselect__select {
        height: 32px;
    }

    .qtrust-select .multiselect__select::before {
        z-index: 1;
        margin: 0;
    }

    .qtrust-select .multiselect__single {
        margin: 0;
        font-size: 14px;
    }
</style>

<style scoped>
    .stats-row {
        padding: 15px 0 5px;
    }
    .stats-row .col:not(:first-child) {
        border-left: 1px solid #ECECEC;
    }
</style>